import { render, staticRenderFns } from "./formScreenFio.vue?vue&type=template&id=58cccb4b&scoped=true"
import script from "./formScreenFio.vue?vue&type=script&lang=js"
export * from "./formScreenFio.vue?vue&type=script&lang=js"
import style0 from "./formScreenFio.vue?vue&type=style&index=0&id=58cccb4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cccb4b",
  null
  
)

export default component.exports